import { useContext, useEffect } from "react";
import { Box, Link, Typography } from "@mui/material";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkTitle from "../../components/atoms/TkTitle";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { TkRouteContext } from "../../context/tkRouteContext";
import { manualList } from "./parts";
import "./_style.scss";

/**
 * SCRC020002 マニュアル等
 * @return SCRC020002 マニュアル等
 */
const SCRC020002 = () => {
  const { state: routerState, setState: setRouterState } =
    useContext(TkRouteContext);
  const filterRouterList = ["/SCRC020001", "/SCRD310001", "/SCRC020002"];

  // パンくずリストをクリアする
  useEffect(() => {
    if (!routerState.routerList?.find((item) => item.href === "/SCRC020002"))
      return;

    const filteredList = routerState.routerList.filter((r) =>
      filterRouterList.includes(r.href ?? "")
    );
    if (
      filteredList.length === routerState.routerList.length &&
      routerState.routerList.every((r, i) => r.href === filteredList[i].href)
    ) {
      return;
    }

    setRouterState({ routerList: filteredList });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routerState.routerList, setRouterState]);

  const manualTableList: {
    title: string;
    subTitle?: string;
    type: "fileLink" | "pageLink" | "node";
    linkName?: string;
    node?: any;
  }[] = [
    {
      title: "退職手当共済システム利用規約",
      type: "fileLink",
      linkName: "退職手当共済システム利用規約.pdf",
    },
    {
      title: "制度マニュアル",
      subTitle:
        "　手続きや届出書類の書き方などを中心に解説した「退職手当共済制度マニュアル」です。ダウンロードして印刷するなどし、ご利用お願いいたします。",
      type: "pageLink",
      linkName: "https://www.wam.go.jp/hp/guide-taisyokuteate-tabid-1528/",
    },
    {
      title: "システムマニュアル",
      type: "node",
      node: (
        <Box>
          <Box className="pageTitle">
            <MenuBookIcon fontSize="large" />
            <Typography>お役立ち・システムマニュアル類</Typography>
          </Box>
          <TkInfoManual>{labelids.labelid.SCRC020002_01}</TkInfoManual>

          {manualList.map((item, index) => (
            <Box key={index} className="field">
              <TkTitle>■{item.title}</TkTitle>
              {item.introduction && (
                <TkInfoManual>{item.introduction}</TkInfoManual>
              )}

              {item.section.map((sec, idx) => (
                <Box key={`${index}-${idx}`} className="section">
                  <Box className="index">{sec.index}</Box>
                  <TkInfoManual rule="\n">{sec.text}</TkInfoManual>
                  <Box className="link">
                    <Typography>{`>>`}</Typography>
                    <Link
                      href={`${process.env.PUBLIC_URL ?? ""}/assets/pdf/${
                        sec.link
                      }`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {sec.link}
                    </Link>
                  </Box>
                </Box>
              ))}
            </Box>
          ))}
        </Box>
      ),
    },
    {
      title: "退職手当金シミュレーション",
      subTitle:
        "　※一定条件の下で計算していますので、実際の退職手当金額を保証するものではありません。",
      type: "pageLink",
      linkName: "https://www.wam.go.jp/hp/guide-taisyokuteate-tabid-424/",
    },
    {
      title: "福祉医療機構（WAM）退職手当共済事業ホームページ",
      type: "pageLink",
      linkName: "https://www.wam.go.jp/hp/cat/taisyokuteate/",
    },
  ];

  return (
    <Box className="SCRC020002" data-testid="SCRC020002PageForTest">
      <Box className="table">
        {manualTableList.map((item) => (
          <Box className="tableLine">
            <Box className="title">
              ■{item.title}
              {item.subTitle && <Box className="subTitle">{item.subTitle}</Box>}
            </Box>

            <Box className="contents">
              {item.type === "fileLink" || item.type === "pageLink" ? (
                <Box className="links">
                  <Link
                    href={
                      item.type === "fileLink"
                        ? `${process.env.PUBLIC_URL ?? ""}/assets/pdf/${
                            item.linkName
                          }`
                        : item.linkName
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                    {item.linkName}
                  </Link>
                  <Typography>（別ウィンドウで開きます）</Typography>
                </Box>
              ) : (
                item.node
              )}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default SCRC020002;
